import { render, staticRenderFns } from "./MyProfile4.vue?vue&type=template&id=4d0475d6"
import script from "./MyProfile4.vue?vue&type=script&lang=js"
export * from "./MyProfile4.vue?vue&type=script&lang=js"
import style0 from "./MyProfile4.vue?vue&type=style&index=0&id=4d0475d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports